import { render, staticRenderFns } from "./ChainProject.vue?vue&type=template&id=7fa6b7ac&scoped=true&"
import script from "./ChainProject.vue?vue&type=script&lang=js&"
export * from "./ChainProject.vue?vue&type=script&lang=js&"
import style0 from "./ChainProject.vue?vue&type=style&index=0&id=7fa6b7ac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa6b7ac",
  null
  
)

export default component.exports